import React from "react";
import { PanelAddUser } from "../../../../UI/Users/Add/PanelAddUser";
import {AddMembership} from "../../../../UI/Membership/Add/AddMembership";

const AddMembershipPage = () => {
  return (
    <div>
      <AddMembership />
    </div>
  );
};

export default React.memo(AddMembershipPage);
